/*** IMPORTS FROM imports-loader ***/
(function() {

define([
  'pip-model',
  'pip-events',
  'pip-overlays__fbtIrgAtcConfirmation',
  'window',
  'jquery'
],
  function(
    pip,
    pipEvents,
    pipOverlayConfirmation,
    window,
    $
  ) {
    function initEventListeners() {
      pipEvents.multiSkuBulk.multiSkuBulkAnalytics.on(function() {
        var contentModule = {
          name: 'buy box',
          feature: 'multi-sku bulk',
          type: 'cta'
        };
        var moduleLoadEvent = {
          category: {
            primaryCategory: 'interaction'
          },
          eventInfo: {
            eventName: 'pip sub-content'
          },
          subContent: {
            component: 'multi-sku bulk',
            section: 'buybox',
            target: 'see eligible items'
          }
        };
        if (window.digitalData && window.digitalData.content && window.digitalData.content.module
          && window.digitalData.event) {
          window.digitalData.content.module.push(contentModule);
          window.digitalData.event.push(moduleLoadEvent);
        }
      });

      pipEvents.multiSkuBulk.multiSkuBulkCartStash.on(function(evtType, viewModel) {
        var displayPosition = 0

        $('.msb__container li').each(function(i) {
          if ($(this).attr('data-itemid') === viewModel.selectedItem.itemId) {
            displayPosition = i + 1;
          }
        })

        var cartStashEvent = {
          eventInfo: {
            eventName: 'cart addition info'
          },
          eventMode: 'stash',
          category: {
            primaryCategory: 'stash'
          },
          isReport: true,
          stash: {
            component: 'product pod',
            pageType: 'pip',
            section: 'buybelt',
            target: 'atc',
            sharedSection: 'multi-sku',
            item: {
              displayPosition: displayPosition,
              productInfo: {
                sku: viewModel.selectedItem.itemId
              }
            }
          }
        }

        if (window.digitalData && window.digitalData.event) {
          window.digitalData.event.push(cartStashEvent);
        }
      });

      pipEvents.multiSkuBulk.multiSkuBulkCartAdd.on(function(evtType, eventData) {
        var cartModel = eventData.cartModel;
        var itemDetails = eventData.itemDetails;
        var singleItemDetails = itemDetails.length > 0 ? itemDetails[0] : itemDetails;
        var itemData = pipOverlayConfirmation.getAnalyticsAtcOverlayEventData(cartModel.itemModels, [singleItemDetails.itemId]).itemsModel;
        itemData = itemData
          .filter(function (item) {
            return item.fulfillment.method === singleItemDetails.fulfillmentMethod;
          })
          .map(function (item) {
            if (singleItemDetails.fulfillmentMethod === 'BOPIS') {
              item.quantity = singleItemDetails.bopisQuantityIncrease || 0;
            } else if (singleItemDetails.fulfillmentMethod === 'ShipToHome') {
              item.quantity = singleItemDetails.sthQuantityIncrease || 0;
            }

            return item;
          });

        var cartAddEvent = {
          category: {
            primaryCategory: 'add to cart click'
          },
          eventInfo: {
            eventName: 'cart add'
          },
          cart: {
            cartID: cartModel.orderId
          },
          item: itemData
        };

        if (window.digitalData && window.digitalData.event) {
          window.digitalData.event.push(cartAddEvent);
        }
      });
    }

    return {
      init: function() {
        if (pip.features.multiSkuBulkPromotionUIEnabled && pip.multiSkuBulkPromotion && !pipEvents.multiSkuBulk.multiSkuBulkAnalytics.subscribers.callbacks.length) {
          initEventListeners();
        }
      }
    }
  });

}.call(window));